var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backup"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gotop),expression:"gotop"}],staticClass:"backup-view",on:{"click":_vm.toTop}},[_c('span',{staticClass:"el-icon-arrow-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }